<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_783)">
    <path
      d="M9.81107 9.43537C10.9827 7.067 11.5686 5.88281 12.5 5.88281C13.4315 5.88281 14.0173 7.067 15.189 9.43537L17.584 14.2766C18.5446 16.2185 19.025 17.1894 18.5849 17.8981C18.1448 18.6068 17.0616 18.6068 14.895 18.6068H10.105C7.93847 18.6068 6.8552 18.6068 6.41512 17.8981C5.97504 17.1894 6.45538 16.2185 7.41606 14.2766L9.81107 9.43537Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_783">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
